import { TrainingStatusEnum } from 'app/models';

export class RiderTrainingStatusModel {
    public static RiderTrainingStatusList: Array<any> = [
        { value: null, name: 'All' },
        { value: TrainingStatusEnum.None, name: 'Pending' },
        { value: TrainingStatusEnum.ScheduledTraining, name: 'Scheduled' },
        { value: TrainingStatusEnum.PassedTraining, name: 'Passed' }
    ];
}
